/* hoh-npc-launch.js · NPC lane (Jan, 2026-09-23) · the hero page's door to Roll an Encounter.

   "leverage the already made page from the encounters and just add it there". The hero
   page's Use as NPC opens the Hall's own encounter tools (hoh-tools.js) on this hero.

   Contract (the hero page lane calls this):
     window.hohNpcOpen(heroIdOrSlug) -> Promise
       Loads hoh-tools.css, hoh-tools-seeds.js and hoh-tools.js once, on first use (so
       the page's first paint and LCP never wait for them), then opens the tools on that
       hero and resolves once the tools are on screen. It rejects, with a message a player
       can read, when the files cannot load; the next call tries again.
     window.hohNpcWarm() -> Promise
       Starts that same load early (hover, focus or touch on the button). Optional.
   The three URLs come from window.HOH_TOOLS_ASSETS = {css, seeds, js}, which
   sections/hoh-hero-page.liquid writes with asset_url.

   Every hero page visit is also noted on this device (localStorage
   'hoh-recent-heroes-v1': the ?h= refs, distinct, newest first, at most 12), so the
   tools' Find list can offer the last four heroes this visitor opened. */
(function(){
  'use strict';
  if(typeof window === 'undefined' || window.hohNpcOpen) return;
  var RECENT = 'hoh-recent-heroes-v1', CAP = 12;

  function pageRef(){
    try { var q = new URLSearchParams(location.search); return String(q.get('h') || q.get('hero') || '').trim().slice(0, 120); } catch(_){ return ''; }
  }
  function remember(ref){
    if(!ref) return;
    try {
      var list = JSON.parse(localStorage.getItem(RECENT) || '[]'), low = ref.toLowerCase();
      if(!Array.isArray(list)) list = [];
      list = [ref].concat(list.filter(function(x){ return typeof x === 'string' && x.trim() && x.trim().toLowerCase() !== low; })).slice(0, CAP);
      localStorage.setItem(RECENT, JSON.stringify(list));
    } catch(_){}
  }
  remember(pageRef());

  /* the element a player last clicked, so focus can go back to it when the tools close
     (Safari does not focus a clicked button, so document.activeElement is not enough) */
  var lastTap = null, lastTapAt = 0;
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('button, a[href], [role="button"], [tabindex]') : null;
    if(t){ lastTap = t; lastTapAt = Date.now(); }
  }, true);

  var loading = null;
  function assets(){ var a = window.HOH_TOOLS_ASSETS || {}; return { css: a.css || '', seeds: a.seeds || '', js: a.js || '' }; }
  function css(url){
    return new Promise(function(resolve, reject){
      if(!url) return reject(new Error('missing'));
      var have = Array.prototype.filter.call(document.querySelectorAll('link[rel="stylesheet"]'), function(l){ return l.getAttribute('href') === url; })[0];
      if(have && have.sheet) return resolve();
      if(have) have.remove();
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = url;
      l.onload = function(){ resolve(); };
      l.onerror = function(){ l.remove(); reject(new Error('css')); };
      document.head.appendChild(l);
    });
  }
  function script(url){
    return new Promise(function(resolve, reject){
      if(!url) return reject(new Error('missing'));
      var s = document.createElement('script'); s.src = url; s.async = false;
      s.onload = function(){ resolve(); };
      s.onerror = function(){ s.remove(); reject(new Error('js')); };
      document.head.appendChild(s);
    });
  }
  function ready(){ return !!(window.hohTools && typeof window.hohTools.open === 'function'); }
  function load(){
    if(ready()) return Promise.resolve();
    if(loading) return loading;
    var a = assets();
    /* the seeds are six reviewed heroes' starter scenes: the tools work without them */
    var seeds = window.HOH_TOOLS_SEEDS ? Promise.resolve() : script(a.seeds).catch(function(){});
    loading = Promise.all([css(a.css), seeds]).then(function(){ return ready() ? null : script(a.js); }).then(function(){
      if(!ready()) throw new Error('tools');
    });
    loading.catch(function(){ loading = null; failedAt = Date.now(); });
    return loading;
  }
  var failedAt = 0;
  window.hohNpcWarm = function(){ var p = load(); p.catch(function(){}); return p; };
  window.hohNpcOpen = function(heroIdOrSlug){
    var ref = String(heroIdOrSlug == null ? '' : heroIdOrSlug).trim() || pageRef();
    var opener = (lastTap && lastTap.isConnected && Date.now() - lastTapAt < 4000) ? lastTap : (document.activeElement !== document.body ? document.activeElement : null);
    return load().then(function(){
      /* open() shows the tools before its first await, so they are on screen here */
      Promise.resolve(window.hohTools.open(ref || null, { encounter: true, opener: opener })).catch(function(){});
    }, function(){
      throw new Error('The encounter tools didn’t load. Check your connection and try again.');
    });
  };
  /* warm on intent: the hero page's Use as NPC button carries data-act="npc"; after a
     failed load, hovering does not retry for ten seconds (a tap always does) */
  function warm(e){ var t = e.target && e.target.closest && e.target.closest('[data-act="npc"]'); if(t && Date.now() - failedAt > 10000) window.hohNpcWarm(); }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('focusin', warm);
})();
